export default "__VITE_ASSET__CThkVN4t__"